import getCloudinaryUrl from './get-cloudinary-url';

function cloudinaryFactory(cloudinaryUrl) {
  return {
    url: getCloudinaryUrl(cloudinaryUrl)
  };
}

export default cloudinaryFactory;
